import { render, staticRenderFns } from "./SetLanguageDialog.vue?vue&type=template&id=3fba0dba&scoped=true"
import script from "./SetLanguageDialog.vue?vue&type=script&lang=js"
export * from "./SetLanguageDialog.vue?vue&type=script&lang=js"
import style0 from "./SetLanguageDialog.vue?vue&type=style&index=0&id=3fba0dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba0dba",
  null
  
)

export default component.exports